export default {
  statusPageRoot: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "fixed",
    zIndex: "1",
    top: "0",
    height: "100%",
    width: "100%",
    padding: "16px",
    color: "#fff",
    overflow: "auto"
  },
  statusPageButton: {
    background: "#fff",
    color: "#1e69d2",
    borderRadius: "0px",
    padding: "16px 24px",
    marginTop: "24px",
    minHeight: "56px"
  },
  error: {
    color: "#e02020"
  }
};
